// Auto-generated by scripts/generate-registry.mjs from packages/modules/aa_aaa_battery_tray/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const aa_aaa_battery_tray: ModuleSchema = {
  "id": "aa_aaa_battery_tray",
  "uniqueId": "B3D_OSW12",
  "createdAt": "2026-10-08T11:08:54.300Z",
  "updatedAt": "2026-10-28T14:57:47.695Z",
  "label": "AA AAA Tray",
  "description": "Single-piece battery organizer with separate AA and AAA wells, built from the reusable grid-hole-tray core.",
  "category": "gadgets",
  "tags": [
    "battery",
    "AA",
    "AAA",
    "organizer",
    "core-grid-hole-tray"
  ],
  "sliders": [
    {
      "key": "height",
      "label": "Tray Height",
      "min": 12,
      "max": 80,
      "step": 1,
      "default": 32,
      "unit": "mm"
    },
    {
      "key": "columns",
      "label": "AA Batteries per Row",
      "min": 1,
      "max": 16,
      "step": 1,
      "default": 8
    },
    {
      "key": "rows",
      "label": "Total Rows",
      "min": 1,
      "max": 16,
      "step": 1,
      "default": 5
    },
    {
      "key": "smallBatteryRows",
      "label": "Rows for AAA",
      "min": 0,
      "max": 16,
      "step": 1,
      "default": 2
    },
    {
      "key": "smallBatteryColumns",
      "label": "AAA Batteries per Row",
      "min": 1,
      "max": 16,
      "step": 1,
      "default": 10
    },
    {
      "key": "aaaDiameter",
      "label": "AAA Nominal Diameter",
      "min": 8,
      "max": 13,
      "step": 0.1,
      "default": 10.5,
      "unit": "mm"
    },
    {
      "key": "aaDiameter",
      "label": "AA Nominal Diameter",
      "min": 12,
      "max": 17,
      "step": 0.1,
      "default": 14.5,
      "unit": "mm"
    },
    {
      "key": "fitClearance",
      "label": "Hole Diametral Clearance",
      "min": 0,
      "max": 1.5,
      "step": 0.1,
      "default": 0.5,
      "unit": "mm"
    },
    {
      "key": "pitchX",
      "label": "Gap Between Wells Across Row",
      "min": 0,
      "max": 10,
      "step": 0.5,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "pitchY",
      "label": "Gap Between Well Rows",
      "min": 0,
      "max": 10,
      "step": 0.5,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "edgeMargin",
      "label": "Outer Margin Around Wells",
      "min": 3,
      "max": 25,
      "step": 0.5,
      "default": 3,
      "unit": "mm"
    },
    {
      "key": "wallThickness",
      "label": "Outer Wall Thickness",
      "min": 1.2,
      "max": 10,
      "step": 0.2,
      "default": 3,
      "unit": "mm"
    },
    {
      "key": "floorThickness",
      "label": "Bottom Thickness",
      "min": 1.2,
      "max": 10,
      "step": 0.2,
      "default": 3,
      "unit": "mm"
    },
    {
      "key": "holeMouthRound",
      "label": "Hole Mouth Roundover",
      "min": 0,
      "max": 1.5,
      "step": 0.1,
      "default": 0.4,
      "unit": "mm"
    },
    {
      "key": "sideRibSpacing",
      "label": "Groove Spacing",
      "min": 2,
      "max": 12,
      "step": 0.5,
      "default": 5,
      "unit": "mm"
    },
    {
      "key": "sideRibWidth",
      "label": "Groove Width",
      "min": 0.5,
      "max": 4,
      "step": 0.1,
      "default": 1.5,
      "unit": "mm"
    },
    {
      "key": "sideRibDepth",
      "label": "Recessed Groove Depth (0 disables)",
      "min": 0,
      "max": 3,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "battery_tray",
      "label": "AA / AAA Battery Tray",
      "default": "#9E9E9E",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "aa_aaa_battery_tray_obj",
      "label": "AA / AAA Battery Organizer",
      "name": "AA / AAA Battery Organizer",
      "color": "#9E9E9E",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "battery_tray",
          "label": "AA / AAA Battery Tray",
          "name": "AA / AAA Battery Tray",
          "groupId": 0,
          "colorKey": "battery_tray",
          "defaultColor": "#9E9E9E",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Complete Battery Tray",
      "targetGroupId": -1,
      "default": true
    }
  ]
};
